import { motion } from "framer-motion";
import MiniScene, { Lift } from "./MiniScene";
import { Greenhouse } from "./sceneSeason";

const ease = [0.32, 0.72, 0, 1];
const GREEN = "#30A14E";
const RED = "#FF3B30";
const BLUE = "#0A84FF";
const T = 4.4;

const Wheel = ({ cx }) => (
  <g>
    <circle cx={cx} cy="128" r="6.5" fill="#1C1C1E" />
    <circle cx={cx} cy="128" r="2.6" fill="#C7C7CC" />
  </g>
);

const Plant = ({ s = 1 }) => (
  <g transform={`scale(${s})`}>
    <path d="M-7 134 h14 l-1.8 -12 h-10.4 Z" fill="#C8754B" />
    <path d="M0 122 C0 112 -4 107 -10 106 C-4 104 0 108 0 114 C0 106 5 101 11 102 C5 104 1.2 110 1.2 122 Z" fill={GREEN} />
  </g>
);

const flash = (delay) => ({ animate: { opacity: [1, 0.15, 1] }, transition: { duration: 0.5, repeat: Infinity, delay } });

// An ambulance collects the plant at the greenhouse and rushes it to the Plant ICU.
export default function AmbulanceArt() {
  return (
    <MiniScene testid="ambulance-art" pines={[[96, 26], [110, 36], [126, 22], [176, 24], [292, 30]]}>

        <motion.g initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, ease }}>
          <Lift><Greenhouse x={8} s={0.8} color={GREEN} id="amb-glass" /></Lift>
        </motion.g>

        <motion.g initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6, delay: 0.15, ease }}><g transform="translate(46 0)">
          <rect x="150" y="78" width="84" height="56" rx="5" fill="#FFFFFF" stroke="#C7C7CC" strokeWidth="2" />
          <rect x="150" y="78" width="84" height="13" rx="5" fill={RED} />
          <text x="192" y="87.6" textAnchor="middle" fontSize="7.5" fontWeight="700" letterSpacing="1" fill="#fff" style={{ fontFamily: "inherit" }}>PLANT ICU</text>
          <path d="M189 64 h6 v5 h5 v6 h-5 v5 h-6 v-5 h-5 v-6 h5 Z" fill={RED} />
          <rect x="202" y="98" width="24" height="18" rx="2.5" fill={BLUE} fillOpacity="0.1" stroke="hsl(var(--muted-foreground) / 0.35)" strokeWidth="1.5" />
          <rect x="160" y="98" width="16" height="14" rx="2" fill={BLUE} fillOpacity="0.1" stroke="hsl(var(--muted-foreground) / 0.35)" strokeWidth="1.5" />
          <rect x="180" y="112" width="16" height="22" rx="2" fill="#E5E5EA" stroke="#C7C7CC" strokeWidth="1.5" /></g>
        </motion.g>

        {/* Plant waits at the door, then hops into the ambulance */}
        <motion.g initial={{ x: 44, opacity: 0 }} animate={{ x: [44, 44, 44, 74], y: [0, 0, 0, -10], opacity: [0, 1, 1, 0], scale: [1, 1, 1, 0.7] }}
          transition={{ duration: T * 0.48, times: [0, 0.15, 0.72, 1], ease }}>
          <Plant />
        </motion.g>

        {/* Safe in the ICU window, with a heartbeat */}
        <motion.g initial={{ opacity: 0, scale: 0.6 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: T * 0.86, type: "spring", stiffness: 300, damping: 18 }} style={{ transformOrigin: "260px 116px" }}>
          <g transform="translate(260 32.9) scale(0.62)"><Plant /></g>
        </motion.g>
        <motion.path d="M200 74 h10 l3 -6 l4 11 l3 -5 h8" stroke={GREEN} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none"
          initial={{ pathLength: 0, opacity: 0 }} animate={{ pathLength: [0, 1, 1], opacity: [1, 1, 0] }} transition={{ delay: T * 0.92, duration: 1.4, repeat: Infinity, repeatDelay: 0.4 }} />

        {/* Ambulance: arrives at the greenhouse, then rushes to the ICU */}
        <motion.g initial={{ x: -200 }} animate={{ x: [-200, -38, -38, 14] }} transition={{ duration: T, times: [0, 0.3, 0.5, 0.82], ease: "easeInOut" }}>
          <path d="M104 128 V102 Q104 98 108 98 H150 V108 H164 L173 116 Q175 118 175 121 V128 Z" fill="#FFFFFF" stroke="hsl(var(--muted-foreground) / 0.5)" strokeWidth="1.5" strokeLinejoin="round" />
          <rect x="104.8" y="117" width="69.5" height="3.2" fill={RED} />
          <path d="M125 104 h4 v3.5 h3.5 v4 h-3.5 v3.5 h-4 v-3.5 h-3.5 v-4 h3.5 Z" fill={RED} />
          <path d="M152 110 H163 L169.5 115.5 H152 Z" fill="#AEAEB2" fillOpacity="0.65" />
          <rect x="172" y="121" width="3.5" height="3" rx="1" fill="#FFD60A" />
          <motion.rect x="137" y="93.5" width="6" height="4.5" rx="1.2" fill={RED} {...flash(0)} />
          <motion.rect x="144" y="93.5" width="6" height="4.5" rx="1.2" fill={BLUE} {...flash(0.25)} />
          <motion.circle cx="140" cy="95.5" r="7" fill={RED} fillOpacity="0.35" style={{ filter: "blur(3px)" }} {...flash(0)} />
          <motion.circle cx="147" cy="95.5" r="7" fill={BLUE} fillOpacity="0.35" style={{ filter: "blur(3px)" }} {...flash(0.25)} />
          <Wheel cx={118} /><Wheel cx={161} />
        </motion.g>
    </MiniScene>
  );
}
